<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="d-flex justify-content-between mt-0">
                <h5 class="card-title">Upcoming Sessions</h5>
                <div class="d-flex justify-content-between">
                    <div class="btn-group ">
                        <button type="button" class="btn btn-btn-toggle" [ngClass]="{'selected':searchRange=='w'}" (click)="toggleSearchRange('w')">Week</button>
                        <button type="button" class="btn btn-btn-toggle" [ngClass]="{'selected':searchRange=='m'}" (click)="toggleSearchRange('m')">Month</button>
                    </div>
                    <div class="mx-2">
                        <i class="fas fa-tasks pull-left card-icon col-orange font-30"></i>
                    </div>

                </div>

            </div>



        </div>
        <div class="row d-flex justify-content-start ">
            <div class="col-auto padding-10">
                <span class="badge col-blue shadow-style m-r-10 ">
                    <h3>{{monthName}}</h3>
                    <h4>{{day}}</h4>
                </span>
            </div>

        </div>
        <div class="row " *ngIf="bookings?.length===0">
            <div class="col-auto-md-12 m-t-25">
                <h3>Sorry no Upcoming Sessions today.</h3>
            </div>
        </div>
        <div class="row" *ngIf="bookings?.length>0">

            <div class="col-auto-md-12 ">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between" *ngFor="let booking of bookings"  [ngClass]="{'expired':isExpired(booking.startDateTime)}">
                      <ng-container *ngIf="!isExpired(booking.startDateTime)">
                      <div>
                            <h3>{{booking.startDateTime|date: 'MMM d, yyyy @ h:mm a'}}</h3>
                            <ng-container *ngIf="user.userId == booking.studentId">
                                <h5>Session with instructor {{booking.instructorName}}</h5>
                            </ng-container>
                            <ng-container *ngIf="user.userId == booking.instructorId">
                                <h5>Instructor Session with {{booking.studentName}}</h5>
                            </ng-container>
                        </div>
                        <div *ngIf="!isExpired(booking.startDateTime)">
                            <button mat-stroked-button color="primary" class="me-2" (click)="messageUser(booking)">Message</button>
                            <button mat-stroked-button color="primary" (click)="openMeeting(booking)">Join</button>
                        </div>
                        </ng-container>
                    </li>
                </ul>
            </div>

        </div>
    </div>
